export const AUTHENTICATE = 'AUTHENTICATE';
export const AUTHENTICATE_OK = 'AUTHENTICATE_OK';
export const AUTHENTICATE_ERROR = 'AUTHENTICATE_ERROR';
export const UNAUTHENTICATE = 'UNAUTHENTICATE';
export const CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT';
